import 'twin.macro';
import 'styled-components/macro';
import * as React from 'react';

import { useTrackAmplitudeEvent } from 'support/amplitude/amplitudeEvent';

export interface TrackLoadingIndicatorProps {
  loading?: boolean;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const TrackLoadingIndicator = ({ loading, title, subtitle }: TrackLoadingIndicatorProps) => {
  const trackAmplitudeEvent = useTrackAmplitudeEvent();

  const onClickTimer = () => {
    trackAmplitudeEvent({ name: 'Lab - Challenge - Clicked environment loading timer' });
  };

  return (
    <div
      tw="leading-snug pl-6 relative text-white whitespace-nowrap text-right"
      aria-busy={loading}
      aria-live="assertive"
      role="alert"
      onClick={onClickTimer}
    >
      {title && <div tw="text-base">{title}</div>}
      {subtitle && <div tw="opacity-70 text-sm">{subtitle}</div>}
    </div>
  );
};
